export default "__VITE_ASSET__Beq5frCx__"